// extracted by mini-css-extract-plugin
module.exports = {"section":"C_section__pUSeQ"};